import React from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Home from "./Pages/Home";
import {
  AuthPages,
  ProjectPages,
  SitePages,
  UserPages,
  ProfilePages,
  BillPages,
  DrivePages,
  attendancePages,
  Dashboard,
  TaskMasterPages,
  AnnouncementPages,
  InventoryPages,
  ApprovalPages,
  MRRPages,
  ProcurementGRNPages,
  ProcurementMRRPages,
  VendorMasterPages,
  ClientMasterPages,
  VendorGoodsNotePages,
  StockAdjustmentNotePages,
} from "./Pages";
import * as routes from "./routes";
import { Layout, Common } from "./Components";
import { SiteContextProvider, UserContextProvider } from "./Context";
import { NotFound } from "./Components/Common";

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          loading: {
            icon: <Common.Spinner size={4} />,
          },
        }}
      />
      <UserContextProvider>
        <Routes>
          <Route element={<Layout.PublicLayout />}>
            <Route path={routes.LOGIN} element={<AuthPages.Login />} />
            <Route path={routes.SIGNUP} element={<AuthPages.SignUpForm />} />
            <Route
              path={routes.RESET_PASSWORD_REQUEST}
              element={<AuthPages.ResetPasswordRequestPage />}
            />
            <Route
              path={routes.RESET_PASSWORD}
              element={<AuthPages.ResetPasswordPage />}
            />
          </Route>
          <Route element={<Layout.Layout />}>
            <Route path={routes.HOME} element={<Home />} />
            <Route path={routes.PROFILE} element={<ProfilePages.Profile />} />
            <Route path={routes.USERS_LIST} element={<UserPages.UserList />} />
            <Route path={routes.DRIVE} element={<DrivePages.FolderRoot />} />
          </Route>
          <Route element={<Layout.Layout />}>
            <Route path={routes.DASHBOARD} element={<Dashboard.Dashboard />} />
            <Route
              path={routes.APPROVALS}
              element={<ApprovalPages.ApprovalListPage />}
            />
            <Route
              path={routes.PROJECT_LIST}
              element={<ProjectPages.ProjectListPage />}
            />
            <Route
              path={routes.CREATE_PROJECT}
              element={<ProjectPages.CreateProject />}
            />
            <Route path={routes.BILLS_LIST} element={<BillPages.ViewBills />} />
            <Route
              path={routes.ADD_BILL}
              element={<BillPages.BillOperations />}
            />
            <Route
              path={routes.VIEW_BILL}
              element={<BillPages.BillOperations />}
            />
            <Route
              path={routes.ADVANCE_NOTES_LIST}
              element={<BillPages.AdvanceNoteList />}
            />
            <Route
              path={routes.CREATE_ADVANCE_NOTE}
              element={<BillPages.AdvanceNoteAction />}
            />
            <Route
              path={routes.VIEW_ADVANCE_NOTE}
              element={<BillPages.AdvanceNoteAction />}
            />
            <Route
              path={routes.EDIT_ADVANCE_NOTE}
              element={<BillPages.AdvanceNoteAction />}
            />
            <Route
              path={routes.USER_LEDGER_LIST}
              element={<BillPages.UserLedger />}
            />
            <Route
              path={routes.PROJECT_LEDGER_LIST}
              element={<BillPages.ProjectLedger />}
            />
            <Route
              path={routes.VIEW_PROJECT}
              element={<ProjectPages.ProjectDetailsPage />}
            />
            <Route
              path={routes.VIEW_MATERIAL_REQUESTS}
              element={<MRRPages.MaterialListPage />}
            />
            <Route path={routes.CREATE_MRR} element={<MRRPages.CreateMRRs />} />
            <Route
              path={routes.VIEW_DETAILED_MRR}
              element={<MRRPages.MRRDetailsPage />}
            />
            <Route path={routes.EDIT_MRR} element={<MRRPages.CreateMRRs />} />
            <Route path={routes.TASK_LIST} element={<SitePages.ListTasks />} />
            <Route
              path={routes.SITE_LIST}
              element={
                <SiteContextProvider>
                  <SitePages.SiteList />
                </SiteContextProvider>
              }
            />
            <Route
              path={routes.SITE_DETAILS}
              element={
                <SiteContextProvider>
                  <SitePages.SiteDetails />
                </SiteContextProvider>
              }
            />
            <Route
              path={routes.CREATE_SITE}
              element={
                <SiteContextProvider>
                  <SitePages.CreateSite />
                </SiteContextProvider>
              }
            />
            <Route
              path={routes.TASK_DETAILS}
              element={
                <SiteContextProvider>
                  <SitePages.TaskDetails />
                </SiteContextProvider>
              }
            />
            <Route
              path={routes.ATTENDANCE_LIST}
              element={<attendancePages.ListAttendance />}
            />
            <Route
              path={routes.CHECK_IN}
              element={<attendancePages.CheckIn />}
            />
            <Route
              path={routes.CHECK_OUT}
              element={<attendancePages.CheckOut />}
            />
            <Route
              path={routes.BACK_DATED}
              element={<attendancePages.Backdated />}
            />
            <Route
              path={routes.VIEW_DETAILED_PAGE}
              element={<attendancePages.DetailedViewPage />}
            />
            <Route
              path={routes.TASK_MASTER_LIST}
              element={<TaskMasterPages.TaskMasterList />}
            />
            <Route
              path={routes.CREATE_TASK_MASTER}
              element={<TaskMasterPages.CreateTaskMaster />}
            />
            <Route
              path={routes.ANNOUNCEMENT}
              element={<AnnouncementPages.AnnouncementList />}
            />
            <Route
              path={routes.WAREHOUSE_MASTER}
              element={<InventoryPages.WarehouseMasterList />}
            />
            <Route path={routes.STOCK} element={<InventoryPages.StockList />} />
            <Route
              path={routes.DISPATCH_NOTE}
              element={<InventoryPages.DispatchNoteList />}
            />
            <Route
              path={routes.RETURN_NOTE}
              element={<InventoryPages.ReturnNoteList />}
            />
            <Route
              path={routes.ADD_RETURN_NOTE}
              element={<InventoryPages.ReturnNoteCreate />}
            />
            <Route
              path={routes.DETAIL_RETURN_NOTE}
              element={<InventoryPages.ReturnNoteCreate />}
            />
            <Route
              path={routes.EDIT_RETURN_NOTE}
              element={<InventoryPages.ReturnNoteCreate />}
            />
            <Route
              path={routes.DISPATCH_NOTE}
              element={<InventoryPages.DispatchNoteList />}
            />
            <Route
              path={routes.CREATE_DISPATCH_NOTE}
              element={<InventoryPages.DispatchNoteAction />}
            />
            <Route
              path={routes.DETAIL_DISPATCH_NOTE}
              element={<InventoryPages.DispatchNoteAction />}
            />
            <Route
              path={routes.EDIT_DISPATCH_NOTE}
              element={<InventoryPages.DispatchNoteAction />}
            />
            <Route
              path={routes.PRODUCT_MASTER}
              element={<InventoryPages.ProductMasterList />}
            />
            <Route
              path={routes.CREATE_PRODUCT_MASTER}
              element={<InventoryPages.CreateProduct />}
            />
            <Route
              path={routes.EDIT_PRODUCT_MASTER}
              element={<InventoryPages.CreateProduct />}
            />
            <Route path={routes.GRN_LIST} element={<ProjectPages.GRNList />} />
            <Route
              path={routes.CREATE_GRN}
              element={<ProjectPages.CreateGRN />}
            />
            <Route
              path={routes.DETAIL_GRN}
              element={<ProjectPages.GRNDetails />}
            />
            <Route
              path={routes.EDIT_GRN}
              element={<ProjectPages.GRNDetails />}
            />
            <Route
              path={routes.PROCUREMENT_GRN}
              element={<ProcurementGRNPages.ProcurementGRNList />}
            />
            <Route
              path={routes.CREATE_PGRN}
              element={<ProcurementGRNPages.ProcrementGRNCreate />}
            />
            <Route
              path={routes.EDIT_PGRN}
              element={<ProcurementGRNPages.ProcrementGRNCreate />}
            />
            <Route
              path={routes.VIEW_DETAILED_PGRN}
              element={<ProcurementGRNPages.ProcrementGRNCreate />}
            />
            <Route
              path={routes.PROCUREMENT_MRR}
              element={<ProcurementMRRPages.ProcurementMRRList />}
            />
            <Route
              path={routes.CREATE_PMRR}
              element={<ProcurementMRRPages.ProcurementMRRCreate />}
            />
            <Route
              path={routes.VIEW_DETAILED_PMRR}
              element={<ProcurementMRRPages.ProcurementMRRCreate />}
            />
            <Route
              path={routes.EDIT_PMRR}
              element={<ProcurementMRRPages.ProcurementMRRCreate />}
            />
            <Route
              path={routes.VENDOR_MASTER}
              element={<VendorMasterPages.VendorMasterList />}
            />
            <Route
              path={routes.CREATE_VENDOR}
              element={<VendorMasterPages.VendorActions />}
            />
            <Route
              path={routes.DETAIL_VENDOR}
              element={<VendorMasterPages.VendorActions />}
            />
            <Route
              path={routes.EDIT_VENDOR}
              element={<VendorMasterPages.VendorActions />}
            />
            <Route
              path={routes.CLIENT_MASTER}
              element={<ClientMasterPages.ClientMasterList />}
            />
            <Route
              path={routes.CREATE_CLIENT}
              element={<ClientMasterPages.ClientActions />}
            />
            <Route
              path={routes.DETAIL_CLIENT}
              element={<ClientMasterPages.ClientActions />}
            />
            <Route
              path={routes.EDIT_CLIENT}
              element={<ClientMasterPages.ClientActions />}
            />
            <Route
              path={routes.VENDOR_LIST}
              element={<VendorGoodsNotePages.VendorGoodsNoteList />}
            />
            <Route
              path={routes.CREATE_VENDOR_GN}
              element={<VendorGoodsNotePages.VendorGoodsNoteActions />}
            />
            <Route
              path={routes.VIEW_VENDOR_GN}
              element={<VendorGoodsNotePages.VendorGoodsNoteActions />}
            />
            <Route
              path={routes.EDIT_VENDOR_GN}
              element={<VendorGoodsNotePages.VendorGoodsNoteActions />}
            />
            <Route
              path={routes.SAN_LIST}
              element={<StockAdjustmentNotePages.StockAdjustmentNoteList />}
            />
            <Route
              path={routes.CREATE_SAN}
              element={<StockAdjustmentNotePages.StockAdjustmentNoteActions />}
            />
            <Route
              path={routes.VIEW_DETAILED_SAN}
              element={<StockAdjustmentNotePages.StockAdjustmentNoteActions />}
            />
            <Route
              path={routes.EDIT_SAN}
              element={<StockAdjustmentNotePages.StockAdjustmentNoteActions />}
            />
            <Route
              path={routes.PRODUCT_META_MASTER}
              element={<InventoryPages.ProductMetaList />}
            />
            <Route
              path={routes.STOCK_TRANSACTION_LEDGER}
              element={<InventoryPages.StockLedgerList />}
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </UserContextProvider>
    </>
  );
}

export default App;
